import { jsx as o } from "react/jsx-runtime";
import { D as m } from "../../vendor-CPVnY93G.js";
import { c as t } from "../../styles.module-BF2N4g8-.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as a } from "../../utils/omitStyleRenderProps/index.js";
function l({ children: e, ...r }) {
  return /* @__PURE__ */ o(m, { ...a(r), className: t.cell, children: e });
}
l.displayName = "Table.Cell";
export {
  l as Cell
};
